<template>
  <base-dialog
    v-if="showPopus"
    :title="title"
    :show="showPopus"
    :show-close="showCancel"
    :close-on-click-modal="showCancel"
    :close-on-press-escap="showCancel"
  >
    <div class="mb-24">
      <span
        ><em class="font-red">*</em>{{ TLang("温馨提示", "address") }}：</span
      >
      <span class="font-c999">
        {{ TLang("notice", "address") }}
      </span>
    </div>
    <el-form ref="address" :model="address" :rules="rules">
      <el-form-item
        :label="TLang('收货人', 'address')"
        prop="consignee"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model="address.consignee"
          :placeholder="TLang('请填写收货人姓名', 'address')"
          @blur="inputBlur('收货人')"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="TLang('手机号', 'address')"
        prop="mobile"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model.number="address.mobile"
          maxlength="11"
          autocomplete="off"
          :placeholder="TLang('请填写收货人手机号码', 'address')"
          @blur="inputBlur('手机号码')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="TLang('所在地区', 'address')"
        prop="areaValue"
        :label-width="formLabelWidth"
      >
        <AddressCascaderNew
          :areaValue="address.areaValue"
          :areaValueEN="address.areaValueEN"
          :areaList="areaList"
          :placeholder="TLang('请选择地址', 'address')"
          @onSetCascaderData="
            (value) => {
              areaValue = Object.values(value);
              address = { ...address, ...value, areaValue };

              if (value.cityId) {
                inputBlur('所在地区');
              }
            }
          "
        />
        <div class="address-tips-form" v-if="checkAddress.length > 0">
          {{ TLang("checkAddressTipsForm", "orderConfirm") }}
        </div>
      </el-form-item>
      <el-form-item
        :label="TLang('详细地址', 'address')"
        prop="address"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model="address.address"
          autocomplete="off"
          :placeholder="TLang('详细地址提示', 'address')"
          @blur="inputBlur('详细地址')"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item
        label="固定号码"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model="address.telephone"
          autocomplete="off"
          placeholder="请输入固定号码"
        ></el-input>
      </el-form-item> -->
      <el-form-item
        :label="TLang('邮政编码', 'address')"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model="address.zipCode"
          @input="
            address.zipCode = isNaN(address.zipCode)
              ? address.zipCode.replace(/[^\d]/g, '')
              : address.zipCode
          "
          autocomplete="off"
          :placeholder="TLang('请输入邮政编码', 'address')"
          @blur="inputBlur('邮件编码')"
        ></el-input>
      </el-form-item>
      <div class="tag-row">
        <span style="width: 145px">{{ TLang("地址标签", "address") }}</span>
        <ul>
          <li
            v-for="(tags, i) in tagList"
            :key="i"
            :class="{ active: tags === tag }"
            @click="
              () => {
                if (tag === tags) {
                  tag = '';
                } else {
                  tag = tags;
                  inputBlur('地址标签', { content: tags });
                }
                tempTag = '';
              }
            "
          >
            {{ tags }}
          </li>
        </ul>
        <input
          v-model="tempTag"
          :placeholder="TLang('tagsLengthTips', 'orderConfirm')"
          maxlength="5"
          @focus="tag = tempTag"
          @change="handleTagChange"
          @input="onTagInput"
          @blur="inputBlur('地址标签', { content: '其他' })"
        />
      </div>
      <div class="setdefault-row">
        <div
          :class="{
            default: !Boolean(defaultAddress),
            default_checked: Boolean(defaultAddress),
          }"
          @click="
            () => {
              if (!Boolean(defaultAddress)) {
                inputBlur('设置为默认收货地址');
              }
              defaultAddress = Number(!Boolean(defaultAddress));
            }
          "
        ></div>
        <div>{{ TLang("设置为默认收货地址", "address") }}</div>
      </div>
      <el-form-item>
        <div class="dialog-footer clearfix mt-32" style="marginleft: 95px">
          <div class="btn-theme-w112 fl" @click="confirm">
            {{ TLang("确定", "address") }}
          </div>
          <div
            v-if="showCancel"
            class="btn-default-w112 ml-24 fl"
            @click="
              () => {
                inputBlur('取消');
                cancelDialog();
              }
            "
          >
            {{ TLang("取消", "address") }}
          </div>
        </div>
      </el-form-item>
    </el-form>
  </base-dialog>
</template>

<script>
/**
 * 地址弹层
 * 编辑或新增地址
 */
import BaseDialog from "@components/dialogV2";
import AddressCascaderNew from "@components/addressCascaderNew";

export default {
  components: { BaseDialog, AddressCascaderNew },
  props: {
    showCancel: {
      type: Boolean,
      default: () => true,
    },
    isClearForm: {
      type: Boolean,
      default: () => true,
    },
    addressItem: {
      default: function () {
        return {};
      },
      type: Object,
    },
    title: String,
    showPopus: Boolean,
    areaList: {
      type: Array,
      default: () => [],
    },
    sendGio: Function,
    dialogState: Boolean,
    checkAddress: Array,
  },
  data() {
    var consignessVerifier = (rule, value, callback) => {
      if (value.indexOf("小姐") !== -1 || value.indexOf("先生") !== -1)
        callback(new Error(this.TLang("newAddressError", "address")));
      callback();
    };

    var mobileVerifier = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value))
        callback(new Error(this.TLang("mobileError", "address")));
      callback();
    };

    var test = (rule, value, callback) => {
      if (
        Object.prototype.toString.call(value) === "[object Array]" &&
        value.length > 4
      ) {
        callback(new Error(this.TLang("所在地区不能为空", "address")));
      }
      callback();
    };

    return {
      formLabelWidth: "145px",
      address: {
        consignee: "",
        mobile: "",
        areaValue: null,
        address: "",
      }, // 绑定创建地址数据
      tempTag: "",
      tag: "",
      defaultAddress: 0,
      tagList: [
        this.TLang("家", "address"),
        this.TLang("公司", "address"),
        this.TLang("学校", "address"),
      ],
      rules: {
        consignee: [
          {
            required: true,
            trigger: "blur",
            message: this.TLang("收货人不能为空", "address"),
          },
          {
            validator: consignessVerifier,
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            trigger: "blur",
            message: this.TLang("手机号码不能为空", "address"),
          },
          { validator: mobileVerifier, trigger: "blur" },
        ],
        areaValue: [
          {
            required: true,
            trigger: "blur",
            message: this.TLang("所在地区不能为空", "address"),
          },
          { validator: test, trigger: "change" },
        ],
        address: [
          {
            required: true,
            trigger: "blur",
            message: this.TLang("详细地址不能为空", "address"),
          },
        ],
      },
    };
  },
  watch: {
    addressItem(val = {}) {
      //  问题： 广东省下面的城市id 和 部分省份id相同， 导致联级选择lazyload 不能回显正确的值
      //  方案： 不用id 作为查询主键值 用id - name 选择之后的回调还是传id
      //  传入的初始值
      if (val && Object.keys(val).length) {
        this.address = { ...val };
        if (!this.tagList.includes(val.tag)) {
          this.tempTag = val.tag;
        } else {
          this.tempTag = "";
        }
        this.tag = val.tag;
        this.defaultAddress = val.defaultAddress;
        this.address.areaValue = [
          val.provinceId + "-" + val.provinceName,
          val.cityId + "-" + val.cityName,
          val.regionId + "-" + val.regionName,
          val.streetId + "-" + val.streetName,
        ];
        this.address.areaValueEN = [
          val.provinceId + "-" + val.provinceNameEn,
          val.cityId + "-" + val.cityNameEn,
          val.regionId + "-" + val.regionNameEn,
          val.streetId + "-" + val.streetNameEn,
        ];
      }
    },
    isClearForm(newVal, oldVal) {
      // debugger
      this.cancelDialog();
    },
  },
  methods: {
    cancelDialog() {
      this.address = {};
      this.$refs["address"].resetFields();
      this.$emit("onCancelEditAddressDialog");
      this.defaultAddress = 0;
      this.tag = "";
      this.tempTag = "";
    },
    confirm() {
      this.$refs["address"].validate((valid) => {
        if (valid) {
          this.$emit("onConfirmEditAddressDialog", {
            ...this.address,
            defaultAddress: this.defaultAddress,
            tag: this.tag || this.tempTag,
          });
          this.inputBlur("确定");
          if (this.isClearForm) {
            this.cancelDialog();
          }
        }
      });
    },
    handleTagChange(e) {
      this.tag = e.target.value;
    },
    onTagInput() {
      let val = this.tempTag.replace(
        /[`~!@#$%^&*()\s_+<>《》。，？「」～【】¥@#%&*（）?:"{},.、\\/;'[\]]/im,
        ""
      );
      this.tempTag = val;
    },
    // 失焦时打点
    inputBlur(elementname, params = {}) {
      this.sendGio && this.sendGio(
        this.dialogState
          ? this.TLang("新增收货地址", "orderConfirm")
          : this.TLang("编辑收货地址", "orderConfirm"),
        elementname,
        params
      );
    },
  },
};
</script>

<style lang="less">
.address-tips-form {
  height: 17px;
  font-size: 12px;
  font-weight: 400;
  color: #ff6600;
  line-height: 17px;
}
.el-form-item__label {
  line-height: 40px !important;
}
.el-dialog__body {
  border-top: solid 1px #e5e5e5;
  padding: 16px 64px 40px;

  .el-form-item {
    margin-bottom: 28px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
      border: solid 1px #e5e5e5;
      color: #333;
      border-radius: 0;
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    .el-cascader {
      width: 100%;
    }
  }
}
.tag-row {
  display: flex;
  align-items: center;
  span {
    width: 95px;
    text-align: right;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
  ul {
    display: flex;
    li {
      min-width: 52px;
      max-width: 120px;
      height: 32px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(229, 229, 229, 1);
      color: rgba(17, 17, 17, 1);
      line-height: 32px;
      text-align: center;
      margin-right: 16px;
    
      &:hover {
        cursor: pointer;
      }
    }
    li.active {
      border: none;
      background: rgba(236, 245, 253, 1);
      color: rgba(61, 150, 226, 1);
      width: 54px;
      height: 34px;
      line-height: 34px;
    }
  }
  input {
    line-height: 32px;
    height: 30px;
  }
}
.setdefault-row {
  display: flex;
  margin-top: 12px;
  padding-left: 86px;
  align-items: center;
  div {
    margin-right: 10px;
  }
  .default {
    width: 14px;
    height: 14px;
    border-radius: 2px;
    border: 1px solid rgba(204, 204, 204, 1);
  }
  .default_checked {
    width: 16px;
    height: 16px;
    background: rgba(61, 150, 226, 1);
    border-radius: 2px;
    position: relative;
    &:after {
      content: "√";
      color: #fff;
      left: 3px;
      top: 0px;
      line-height: 16px;
      font-size: 10px;
      position: absolute;
    }
  }
}
</style>
